import React from 'react'
import type { PresentationSectionProps } from '../../'
import QuoteComponent from '../../../Quote'

export default function WorkOrder(props: PresentationSectionProps) {
  const { WrapperComponent } = props

  return (
    <WrapperComponent {...props}>
      <QuoteComponent inPresentation={true} view="work-order" />
    </WrapperComponent>
  )
}
